module.exports = __webpack_public_path__ + "static/img/training_system_s4_max2.b44baa10.png";